import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { UserSessionService } from '../services/usersession.service';

@Directive({
    selector: '[appFieldReadOnlyHandler]',
    standalone: false
})
export class FieldReadOnlyHandlerDirective {
  @Input() fieldId: number;
  @Input() formId: number;
  UserGroupReadOnlyFields: any[];

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private userSessionService: UserSessionService) { }

  ngOnInit(): void {
    this.UserGroupReadOnlyFields = this.userSessionService.userSessionData?.UserGroup?.IndividualPermission?.UserGroupReadOnlyFields;
    if(this.UserGroupReadOnlyFields.length > 0) {
      const isReadOnly = this.isFieldReadOnly(this.fieldId, this.formId);
      if (isReadOnly) {
        const tag = this.elementRef.nativeElement.tagName.toLowerCase();
        if (tag === 'input') {
          const type = this.elementRef.nativeElement.getAttribute('type');
          if (type === 'checkbox' || type === 'radio') {
            this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
          } else {
            this.renderer.setAttribute(this.elementRef.nativeElement, 'readonly', 'true');
          }
        } else if (tag === 'textarea') {
          this.renderer.setAttribute(this.elementRef.nativeElement, 'readonly', 'true');
        } else if (tag === 'select' || tag === 'button') {
          this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
        } else if (tag === 'ejs-maskedtextbox') {
          setTimeout(() => {
            const input = this.elementRef.nativeElement.querySelector('input');
            if (input) {
              this.renderer.setAttribute(input, 'readonly', 'true');
              this.renderer.setStyle(input, 'background-color', '#e9ecef');
            }
          }, 100);
        }
      }
    }
  }

  isFieldReadOnly(fieldId: number, formId: number): boolean {
    if (this.UserGroupReadOnlyFields) {
      return this.UserGroupReadOnlyFields.some(x => x.MandatoryFieldId === fieldId && x.FormId === formId && x.ReadOnly);
    }
    return false;
  }
}
